import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { UploadErrorPopup } from './UploadErrorPopup.tsx';

export const i18n: {
	tryDifferentDocumentUploadErrorPopupButtonTYPE: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeUploadErrorPopupButtonTYPE: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uploadErrorPopupTitleTYPE: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uploadErrorPopupContentTYPE: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tryDifferentDocumentUploadErrorPopupButtonTYPE: {
		id: 'import-from-sources.upload-error-popup.type-tryDifferentDocument',
		defaultMessage: 'Select another file',
		description:
			'Label for the button that allows user to select a different file after the previous file was rejected due to unsupported file type.',
	},
	closeUploadErrorPopupButtonTYPE: {
		id: 'import-from-sources.upload-error-popup.close',
		defaultMessage: 'Close',
		description: 'Label for the button that closes the file type error popup modal.',
	},
	uploadErrorPopupTitleTYPE: {
		id: 'import-from-sources.upload-error-popup.type-title',
		defaultMessage: 'Only .DOCX files are supported',
		description:
			'Title of the error popup shown when user attempts to import a file with an unsupported file type (only .DOCX is supported).',
	},
	uploadErrorPopupContentTYPE: {
		id: 'import-from-sources.upload-error-popup.type-content',
		defaultMessage:
			'We couldn’t import the file you selected because it is the wrong file type. Select a different file to continue.',
		description:
			'Body text of the error popup explaining that the file type is not supported and instructing the user to select a .DOCX file instead.',
	},
});

export const FileTypeModal: React.FC<{
	onSubmit: () => void;
	onClose: () => void;
}> = ({ onSubmit, onClose }) => {
	return (
		<UploadErrorPopup
			onSubmit={onSubmit}
			onClose={onClose}
			headText={<FormattedMessage {...i18n.uploadErrorPopupTitleTYPE} />}
			bodyText={<FormattedMessage {...i18n.uploadErrorPopupContentTYPE} />}
			submitText={<FormattedMessage {...i18n.tryDifferentDocumentUploadErrorPopupButtonTYPE} />}
			closeText={<FormattedMessage {...i18n.closeUploadErrorPopupButtonTYPE} />}
			modalWidth="small"
		/>
	);
};
